import { CalendarType } from 'domains/models/event_type/calendarType';
import {
  FrequencyType,
  FrequencyTypeText,
} from 'domains/models/event_type_calendar/frequencyType';
import { PeriodType } from 'domains/models/event_type/periodType';
import { ViewerTimeZoneType } from 'domains/models/event_type/viewerTimeZoneType';
import { z } from 'zod';

export const FrequencyTypeTextEnum = z.nativeEnum(FrequencyTypeText);
export const FrequencyTypeEnum = z.nativeEnum(FrequencyType);
export const PeriodTypeEnum = z.nativeEnum(PeriodType);
export const CalendarTypeEnum = z.nativeEnum(CalendarType);
export const ViewerTimeZoneTypeEnum = z.nativeEnum(ViewerTimeZoneType);
